uniform float uTime;
uniform float uPixelRatio;
uniform float uSize;

attribute float aScale;
attribute float aOffset;

varying float vAlpha;

void main()
{
  // 個体ごとに位相をずらした、ゆっくり立ち昇りながら漂う動き
  vec3 pos = position;
  float t = uTime * 0.3 + aOffset * 6.2831;
  pos.y += sin(t) * 0.35 + sin(t * 0.7 + aOffset * 3.0) * 0.15;
  pos.x += cos(t * 0.8) * 0.25;
  pos.z += sin(t * 0.6 + aOffset * 5.0) * 0.25;

  vec4 modelPosition = modelMatrix * vec4(pos, 1.0);
  vec4 viewPosition = viewMatrix * modelPosition;
  gl_Position = projectionMatrix * viewPosition;

  gl_PointSize = uSize * aScale * uPixelRatio;
  gl_PointSize *= (1.0 / -viewPosition.z);

  // ふわっと明滅
  vAlpha = 0.55 + 0.45 * sin(t * 2.0 + aOffset * 10.0);
}
